import {authApi} from 'src/api';
import {useAppDispatch} from 'src/app/hooks';
import {storedRefreshToken} from 'src/axiosBaseQuery/interceprtors';
import {clearAuthInfo} from 'src/stores/common/commonSlice';

/**
 * Ending the session, in one place.
 *
 * Lifted out of the drawer because the phone's More screen logs out from its own tile and a second
 * copy of this would be a second chance to forget the half that matters: clearing storage alone
 * leaves the refresh token valid on the server, so the session stays open to anyone holding it.
 */
export const useLogout = () => {
    const dispatch = useAppDispatch();

    return () => {
        // Ends the session on the server as well. The call is not awaited because the screen must go
        // either way.
        const refreshToken = storedRefreshToken();
        if (refreshToken) {
            void dispatch(authApi.endpoints.logout.initiate({token: refreshToken}));
        }
        localStorage.clear();
        dispatch(clearAuthInfo());
    };
};
